import React from 'react'
import "./Resume.css"
import html2pdf from "html2pdf.js";
import img from "../plateform/assets/users/jese-leos-2x.png"
import { useSelector } from 'react-redux';
import { PATH_END_POINT } from '../../api';
import ButtonHoverAnimated from '../components/Buttons/ButtonHoverAnimated';
import { GoDownload } from 'react-icons/go';

const PrintResume = () => {
    const generatePDF = () => {
      const element = document.getElementById("resume");
      const options = {
        margin: 0,
        filename: "resume.pdf",
        html2canvas: {
        //   scale: 2, // Améliore la qualité
          useCORS: true, // Gère les images distantes
        },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      };
  
      html2pdf().set(options).from(element).save();
    };
  
    return (
      <>
        <button
          onClick={generatePDF}
          className="px-6 py-3 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Download PDF
        </button>

        <div className="resume-container text-start text-xs">
          <main className="main-content" id="resume">
        <section class="left-section">
            <div class="left-content">
                <div class="profile space-y-4">
                    <div class="object-cover size-32 rounded-full mx-auto">
                        <img src={img} alt=""/>
                    </div>
                    <h2 class="text-xl uppercase text-white text-center">John DOE</h2>
                    <p class="text-lg text-blue-200 ">Software Engineer</p>
                </div>
                <div class="contact-info">
                    <h3 class="main-title">Contact Info</h3>
                    <ul>
                        <li>
                            <i class="fa fa-phone"></i>
                            07661892982
                        </li>
                        <li>
                            <i class="fa fa-fax"></i>
                            loremipsum@gmail.com
                        </li>
                        <li>
                            <i class="fa fa-globe"></i>
                            www.loremipsum.com
                        </li>
                        <li>
                            <i class="fa fa-facebook"></i>
                            www.facebook.com/lorem
                        </li>
                        <li>
                            <i class="fa fa-instagram"></i>
                            @loremipsum
                        </li>
                        <li>
                            <i class="fa fa-map-marker"></i>
                            37 Pramount St, London
                        </li>
                    </ul>
                </div>
                <div class="skills-section">
                    <h3 class="main-title">Skills</h3>
                    <ul>
                        <li>
                            <p class="skill-title">Javascript</p>
                            <div class="progress-bar">
                                <div class="progress js-progress"></div>
                            </div>
                        </li>
                        <li>
                            <p class="skill-title">Photoshop</p>
                            <div class="progress-bar">
                                <div class="progress ps-progress"></div>
                            </div>
                        </li>
                        <li>
                            <p class="skill-title">Java</p>
                            <div class="progress-bar">
                                <div class="progress j-progress"></div>
                            </div>
                        </li>
                        <li>
                            <p class="skill-title">C++</p>
                            <div class="progress-bar">
                                <div class="progress c-progress"></div>
                            </div>
                        </li>
                        <li>
                            <p class="skill-title">Ruby</p>
                            <div class="progress-bar">
                                <div class="progress ps-progress"></div>
                            </div>
                        </li>
                        <li>
                            <p class="skill-title">Node js</p>
                            <div class="progress-bar">
                                <div class="progress n-progress"></div>
                            </div>
                        </li>
                        <li>
                            <p class="skill-title">html/css</p>
                            <div class="progress-bar">
                                <div class="progress ps-progress"></div>
                            </div>
                        </li>
                        <li>
                            <p class="skill-title">illustrator</p>
                            <div class="progress-bar">
                                <div class="progress ps-progress"></div>
                            </div>
                        </li>
                        <li>
                            <p class="skill-title">Wordpress</p>
                            <div class="progress-bar">
                                <div class="progress ps-progress"></div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="references-section">
                    <h3 class="main-title">References</h3>
                    <div class="referee">
                        <h6 class="sub-title">Michael Bowen</h6>
                        <p class="sub-para">Product Manager</p>
                        <ul>
                            <li>
                                <i class="fa fa-phone"></i>
                                07661892982
                            </li>
                            <li>
                                <i class="fa fa-fax"></i>
                                loremipsum@gmail.com
                            </li>
                        </ul>
                    </div>
                    <div class="referee">
                        <h6 class="sub-title">Joseph Kumar</h6>
                        <p class="sub-para">Senior Developer</p>
                        <ul>
                            <li>
                                <i class="fa fa-phone"></i>
                                07661892982
                            </li>
                            <li>
                                <i class="fa fa-fax"></i>
                                loremipsum@gmail.com
                            </li>
                        </ul>
                    </div>
                    <div class="referee">
                        <h6 class="sub-title">Rick Ross</h6>
                        <p class="sub-para">Product Manager</p>
                        <ul>
                            <li>
                                <i class="fa fa-phone"></i>
                                07661892982
                            </li>
                            <li>
                                <i class="fa fa-fax"></i>
                                loremipsum@gmail.com
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <section class="right-section">
            <div class="right-main-content">
                <section class="about sect">
                    <h2 class="right-title">About Me</h2>
                    <p class="para ">
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam molestias facilis ullam dolorum, reprehenderit dolorem accusantium sit quo 
                        dolore nostrum assumenda obcaecati animi commodi nobis labore exercitationem corporis esse eveniet optio laudantium molestiae maiores pariatur nisi cumque. 
                        Distinctio et, totam, dicta autem nostrum doloribus ipsam vel rerum, molestiae soluta laboriosam. <br/>
                        <br/>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto iusto porro suscipit. 
                        Nihil blanditiis cum voluptates odio recusandae deleniti, nulla repudiandae aliquam adipisci iusto reiciendis sequi labore quos ratione accusamus consectetur, 
                        libero ex assumenda pariatur commodi animi nobis, dolore id.
                    </p>
                </section>
{/* Section Experience */}
                <section class="experince sect">
                    <h2 class="right-title ">Experience</h2>
                    <div class="timeline">
                        <div class="left-tl-content">
                            <h5 class="tl-title">Microsoft</h5>
                            <p class="para">2017 - 2019</p>
                        </div>
                        <div class="right-tl-content">
                            <div class="tl-content">
                                <h5 class="tl-title-2">Junior Developer</h5>
                                <p class="para">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias cupiditate vitae 
                                    voluptatem deleniti, 
                                    laboriosam odio nobis quae fugit facilis quo.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="timeline">
                        <div class="left-tl-content">
                            <h5 class="tl-title">Google Inc</h5>
                            <p class="para">2019 - 2020</p>
                        </div>
                        <div class="right-tl-content">
                            <div class="tl-content">
                                <h5 class="tl-title-2">Lead Web developer</h5>
                                <p class="para">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias cupiditate vitae 
                                    voluptatem deleniti, 
                                    laboriosam odio nobis quae fugit facilis quo.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="timeline">
                        <div class="left-tl-content">
                            <h5 class="tl-title">Google Inc</h5>
                            <p class="para">2019 - 2020</p>
                        </div>
                        <div class="right-tl-content">
                            <div class="tl-content">
                                <h5 class="tl-title-2">Lead Web developer</h5>
                                <p class="para">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias cupiditate vitae 
                                    voluptatem deleniti, 
                                    laboriosam odio nobis quae fugit facilis quo.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="timeline">
                        <div class="left-tl-content">
                            <h5 class="tl-title">Apple</h5>
                            <p class="para">2020 - Present</p>
                        </div>
                        <div class="right-tl-content">
                            <div class="tl-content">
                                <h5 class="tl-title-2">Senior Developer</h5>
                                <p class="para">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias cupiditate vitae 
                                    voluptatem deleniti, 
                                    laboriosam odio nobis quae fugit facilis quo.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

{/* Section Experience */}
                <section class="education sect">
                    <h2 class="right-title">education</h2>
                    <div class="timeline">
                        <div class="left-tl-content">
                            <h5 class="tl-title">Cheney School</h5>
                            <p class="para">2015 - 2016</p>
                        </div>
                        <div class="right-tl-content">
                            <div class="tl-content">
                                <h5 class="tl-title-2">Gcse's</h5>
                                <p class="para">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias cupiditate vitae 
                                    voluptatem deleniti, 
                                    laboriosam odio nobis quae fugit facilis quo.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="timeline">
                        <div class="left-tl-content">
                            <h5 class="tl-title">Cheney School</h5>
                            <p class="para">2016 - 2018</p>
                        </div>
                        <div class="right-tl-content">
                            <div class="tl-content">
                                <h5 class="tl-title-2">A - Levels</h5>
                                <p class="para">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias cupiditate vitae 
                                    voluptatem deleniti, 
                                    laboriosam odio nobis quae fugit facilis quo.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="timeline">
                        <div class="left-tl-content">
                            <h5 class="tl-title">University of Sussex</h5>
                            <p class="para">2018 - Present</p>
                        </div>
                        <div class="right-tl-content">
                            <div class="tl-content">
                                <h5 class="tl-title-2">Computer Science</h5>
                                <p class="para">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias cupiditate vitae 
                                    voluptatem deleniti, 
                                    laboriosam odio nobis quae fugit facilis quo.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="awards sect">
                    <h2 class="right-title">Awards</h2>
                    <div class="timeline">
                        <div class="left-tl-content">
                            <h5 class="tl-title">Microsoft</h5>
                            <p class="para">June 2016</p>
                        </div>
                        <div class="right-tl-content">
                            <div class="tl-content">
                                <h5 class="tl-title-2">Excellent Work</h5>
                                <p class="para">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias cupiditate vitae 
                                    voluptatem deleniti, 
                                    laboriosam odio nobis quae fugit facilis quo.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="timeline">
                        <div class="left-tl-content">
                            <h5 class="tl-title">Alphabet Inc</h5>
                            <p class="para">June 2016</p>
                        </div>
                        <div class="right-tl-content">
                            <div class="tl-content">
                                <h5 class="tl-title-2">The Star Employee</h5>
                                <p class="para">
                                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Molestias cupiditate vitae 
                                    voluptatem deleniti, 
                                    laboriosam odio nobis quae fugit facilis quo.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </main>
</div>

    </>
  )
}


export default PrintResume

// import { Facebook, Linkedin, Globe } from "lucide-react";

export const PrintResume2 = ({data, buttonText}) => {
      const {user} = useSelector(store=>store.user)

      const generatePDF = () => {
        const element = document.getElementById("resume");
        const options = {
          margin: 0,
          filename: "resume.pdf",
          html2canvas: {
          //   scale: 2, // Améliore la qualité
            // useCORS: true, // Gère les images distantes
            useCORS: true, // Autorise les images distantes
            allowTaint: true, // Permet les images cross-origin
          },
          jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        };
    
        html2pdf().set(options).from(element).save();
      };

  return (
    <>
     <ButtonHoverAnimated
          onClick={generatePDF}
          className="px-4 py-2 rounded-md border text-gray-600 flex items-center gap-x-2"
        >
          {buttonText || <><GoDownload/> Mon CV</>}
        </ButtonHoverAnimated>
        <div className="hidden">
        <div className=" bg-white p-10  text-sm" id="resume">
      {/* Header */}
      <header className="flex items-start ">
        <div className='w-full'>
          <h2 className="font-semibold uppercase tracking-wide  mb-8">Curriculum vitea</h2>
          <p className="text-sm text-gray-600 uppercase mb-2">{data?.current_job}</p>
          <h1 className="text-4xl font-bold pb-6 border-b mb-4 ">{data?.name}</h1>
          <p>
          <span className='font-semibold'>Adresse : </span>
          <span className='text-gray-600'>{data?.address} </span>
          </p>
          <p>
            <span className='font-semibold'>Téléphone : </span>
            <span className='text-gray-600'>{data?.phone} | </span>
            <span className='font-semibold'>Email : </span>
            <span className='text-gray-600'>{user?.email} | </span>
            <span className='text-gray-600'>{data?.potfolio || "Auccun"}</span>
            </p>
        </div>
        <img
          src={PATH_END_POINT + user?.photo}
          alt="profile"
          className="w-40 h-44 object-cover rounded-sm border border-gray-300"
        />
      </header>

      <section className="mt-7 ">
        <h2 className="text-xl font-bold uppercase border-b-2 border-gray-400 pb-4">Experience</h2>
        <div className="mt-4">
          {data?.experiences?.length > 0 ? (
            data?.experiences?.map((exp, index) => (
                (index < 3) &&
              <div key={exp.id} className="mb-4 grid grid-cols-4 space-x-4 items-start">
                <div className=' col-span-1'> 
                    <p className="text-gray-600 text-sm">
                    {exp.start_month} {exp.start_year} -{" "}
                    {exp.currently_working ? "Present" : `${exp.end_month} ${exp.end_year}`}
                    </p>
                </div>
                <div className="col-span-3">
                    <h3 className="font-bold">{exp.company}</h3>
                    <p className=""> {exp.job_type}</p>
                    <p className="text-gray-600 text-sm mt-1">{exp.description}</p>  
                </div>
              
              </div>
            ))
          ) : (
            <p className="text-gray-600">Aucune expérience disponible.</p>
          )}
        </div>
      </section>

         {/* <section className="mt-7 ">
        <h2 className="text-xl font-bold uppercase border-b-2 border-gray-400 pb-4">Experience</h2>
        <div className="mt-4">
          {data?.experiences?.length > 0 ? (
            data?.experiences?.map((exp, index) => (
                (index < 3) &&
              <div key={exp.id} className="mb-4">
                <h3 className="font-bold">{exp.company}</h3>
                <p className="text-gray-600 text-sm">
                  {exp.job_type} | {exp.start_month} {exp.start_year} -{" "}
                  {exp.currently_working ? "Present" : `${exp.end_month} ${exp.end_year}`}
                </p>
                <p className="text-gray-600 text-sm mt-1">{exp.description}</p>
              </div>
            ))
          ) : (
            <p className="text-gray-600">Aucune expérience disponible.</p>
          )}
        </div>
      </section> */}

       <section className="mt-7 ">
        <h2 className="text-xl font-bold uppercase border-b-2 border-gray-400 pb-4">Education</h2>
        <div className="mt-4">
          {data?.educations?.length > 0 ? (
            data?.educations?.map((edu, index) => (
                (index < 2) &&
              <div key={edu.id} className="mb-4 grid grid-cols-4 space-x-4 items-start">
                 <div className=' col-span-1'> 
                    <p className="text-gray-600 text-sm">
                    {edu.start_month} {edu.start_year} - {edu.end_month} {edu.end_year}
                    </p>
                </div>
                <div className="col-span-3">
                    <h3 className="font-bold">{edu.diploma || "Diplôme non spécifié"}</h3>
            <p className="text-gray-600">{edu.school}</p>
                    {edu.description && (
                        <p className="text-gray-600 text-sm mt-1" dangerouslySetInnerHTML={{ __html: edu.description }} />
                    )} 
                </div>                
              </div>
            ))
          ) : (
            <p className="text-gray-600">Aucune formation disponible.</p>
          )}
        </div>
      </section>

      {/* Skills, Statement, Social Media */}
      <div className="grid grid-cols-3 gap-6 mt-7">
        <div className='col-span-2'>
          <h2 className="text-lg font-bold uppercase border-b-2 border-gray-400 pb-4">Compétences</h2>
          <ul className="mt-2 text-sm text-gray-600 text-start grid grid-rows-2 col  gap-1">
            {data?.skills?.length > 0 ? (
                data?.skills?.map((skill, index) => <li key={index} className="py-1">{skill}</li>)
            ) : (
                <p className="text-gray-600">Aucune compétence disponible.</p>
            )}
        </ul>
        </div>
        {/* <div>
          <h2 className="text-lg font-bold uppercase border-b-2 border-gray-400 pb-1">Statement</h2>
          <p className="mt-2 text-sm text-gray-600">A section to describe why the employer should hire you.</p>
        </div> */}
        <div>
          <h2 className="text-lg font-bold uppercase border-b-2 border-gray-400 pb-4">Langue</h2>
          {/* <ul className="mt-2 text-sm text-gray-600">
            <li className="flex items-center gap-2"><FaFacebook size={16} /> facebook.com/anderson.lee</li>
            <li className="flex items-center gap-2"><FaLinkedin size={16} /> linkedin.com/in/anderson.lee</li>
            <li className="flex items-center gap-2"><FaGlobe size={16} /> behance.net/anderson.lee</li>
          </ul> */}
          <ul className="mt-2 text-sm text-gray-600 text-start grid grid-rows-2 col  gap-1">
            {data?.languages?.length > 0 ? (
                data?.languages?.map((lang, index) => <li key={index} className="py-1">{lang?.title+ " : " +lang.merit}</li>)
            ) : (
                <p className="text-gray-600">Aucune compétence disponible.</p>
            )}
        </ul>
        </div>
      </div>
    </div>
        </div>
       
    </>
  
  );
};

// export  PrintResume2;
